export default __webpack_public_path__ + "media/images/icons/tick-green-cf1f1e9250e9e96afb8081abcfd73f3e.svg";